import { useI18n } from "@/i18n/I18nProvider";

export default function Subprocessors() {
  const { t } = useI18n();
  const items = [
    { name: 'Supabase', purposeKey: 'legal.subp.supabase.purpose', purposeFallback: 'Managed Postgres DB, auth, storage', location: 'EU/US', dpa: 'https://supabase.com/privacy#data-processing' },
    { name: 'Vercel', purposeKey: 'legal.subp.vercel.purpose', purposeFallback: 'Application hosting & CDN', location: 'EU/US', dpa: 'https://vercel.com/legal/dpa' },
    { name: 'Stripe', purposeKey: 'legal.subp.stripe.purpose', purposeFallback: 'Payment processing & payouts', location: 'EU/US', dpa: 'https://stripe.com/legal/dpa' },
    { name: 'Resend', purposeKey: 'legal.subp.resend.purpose', purposeFallback: 'Transactional email delivery', location: 'US/EU', dpa: 'https://resend.com/dpa' },
    { name: 'Google (OAuth/Calendar)', purposeKey: 'legal.subp.google.purpose', purposeFallback: 'Identity provider & calendar sync', location: 'Global', dpa: 'https://cloud.google.com/terms/data-processing-terms' },
    { name: 'Iubenda', purposeKey: 'legal.subp.iubenda.purpose', purposeFallback: 'Privacy & Cookie policy hosting/CMP', location: 'EU', dpa: 'https://www.iubenda.com/privacy-policy/terms' },
  ];
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('legal.subp.title', 'Subprocessors')}</h1>
      <p className="text-gray-700 mb-6">{t('legal.subp.intro', 'We engage the following subprocessors to provide our services.')}</p>
      <div className="overflow-x-auto border rounded-lg">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="p-3">{t('legal.subp.col.name', 'Name')}</th>
              <th className="p-3">{t('legal.subp.col.purpose', 'Purpose')}</th>
              <th className="p-3">{t('legal.subp.col.location', 'Location')}</th>
              <th className="p-3">{t('legal.subp.col.dpa', 'DPA / Privacy')}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.name} className="border-t">
                <td className="p-3 font-medium">{it.name}</td>
                <td className="p-3">{t(it.purposeKey, it.purposeFallback)}</td>
                <td className="p-3">{it.location}</td>
                <td className="p-3"><a className="text-primary underline" href={it.dpa} target="_blank" rel="noreferrer">{t('legal.subp.learn_more', 'Learn more')}</a></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
